import {
    Box, Button, Dialog, DialogActions, DialogContent, DialogContentText,
    DialogTitle, FormControl, Grid, InputLabel, Select, Slide, TextField
} from "@mui/material";
import { AxiosInstance } from "axios";
import { Fragment, FC, useState, forwardRef, ReactElement, Ref } from "react";
import CheckAttr from "../../../utils/CheckAttr";
import { useStyles } from "../styles";
import { LoadingButton } from "@mui/lab";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { AlertType } from "../../../types/AlertType";
import { SnackBarAlert } from "../../element/SnackBarAlert";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import CheckIcon from '@mui/icons-material/Check';
import { TransitionProps } from "@mui/material/transitions";
import { TarifInterface } from "../../content/parametrage/Tarification/InterfaceTarification";
import { DataRef } from "../../../types/DataRef";
import { checkViaCodeArticle } from "../../../utils/utils";
import { codeArticleNotToDisable } from "../../../constants/Constants";
import { IPeriodeCloture } from "../../content/production/SaisieAgent";

interface ITarifFormsProps {
    http: AxiosInstance
    rowtarifToUpdate?: TarifInterface;
    reloadList: () => void;
    onClose: () => void;
    allPeriodeClotured:IPeriodeCloture[];
}

interface InputValidation {
    dateDebut: boolean;
    dateFin: boolean;
    tarif: boolean;
}

const resetInpuValidation: InputValidation = {
    dateDebut: false,
    dateFin: false,
    tarif: false,
};

const Transition = forwardRef(function Transition(
    props: TransitionProps & {
        children: ReactElement<any, any>;
    },
    ref: Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});

interface TarifToSave {
    id?: number;
    pays?: number;
    bu?: number;
    client?: number;
    operation_id?: number;
    operation_libelle?: string;
    article_id?: number;
    article_libelle?: string;
    date_debut: string;
    date_fin: string;
    tarif_heure?: string;
    tarif_acte?: string;
}

const DuplicateTarifForm: FC<ITarifFormsProps> = ({
    http,
    rowtarifToUpdate,
    reloadList,
    onClose,
    allPeriodeClotured
}) => {
    const classes = useStyles();

    const [tarifToSave, setTarifToSave] = useState<TarifToSave>({
        id: rowtarifToUpdate?.id,
        pays: rowtarifToUpdate?.article?.pivot_pays_bu?.pays?.id,
        bu: rowtarifToUpdate?.article?.pivot_pays_bu?.business_unit?.id,
        client: rowtarifToUpdate?.article?.piv_oper_soc_code?.operation?.client?.id,
        operation_id: rowtarifToUpdate?.article?.piv_oper_soc_code?.operation?.id,
        operation_libelle: rowtarifToUpdate?.article?.piv_oper_soc_code?.operation?.libelle,
        article_id: rowtarifToUpdate?.article?.id,
        article_libelle: rowtarifToUpdate?.article?.libelle,
        date_debut: rowtarifToUpdate?.date_debut,
        date_fin: rowtarifToUpdate?.date_fin,
        tarif_heure: rowtarifToUpdate?.tarifheure,
        tarif_acte: rowtarifToUpdate?.tarifacte
    });

    const [errorInput, setErrorInput] = useState<InputValidation>(resetInpuValidation);

    const dataPays: DataRef[] = [rowtarifToUpdate?.article?.pivot_pays_bu?.pays!];
    const dataBus: DataRef[] = [rowtarifToUpdate?.article?.pivot_pays_bu?.business_unit!];
    const dataClients: DataRef[] = [rowtarifToUpdate?.article?.piv_oper_soc_code?.operation?.client!];


    const [alertType, setAlertType] = useState<AlertType>("success");
    const [alertMessage, setAlerteMessage] = useState<string>("");
    const [openSnack, setOpenSnack] = useState<boolean>(false);
    const [openModalConfirmation, setOpenModalConfirmation] = useState<boolean>(false);
    const [isClickSave, setIsClickSave] = useState<boolean>(false);

    const handleChange = (e: any) => {
        const { name, value } = e.target;

        if(name === 'date_debut'){
            let TesteSiValueInDateDisable = false;
            allPeriodeClotured.map((dateTmp) => {
                // Si Le Value est Inclu Dans L'un des Periode Cloture
                if(value >= dateTmp.date_debut && value <= dateTmp.date_fin){
                  // Disable
                  setAlerteMessage(
                    `le ${dateTmp.date_debut} a ${dateTmp.date_fin} est Deja Cloturé`
                  );
                  setAlertType("warning");
                  setOpenSnack(true);
          
                  TesteSiValueInDateDisable = true;
                }
            })
        
            if(!TesteSiValueInDateDisable){
                // Si il n'est pas Inclue Dans Tout les Periode Clotures
                setTarifToSave({
                  ...tarifToSave,
                  [name]: value,
                });
            }
            else{
                setTarifToSave({
                    ...tarifToSave,
                    [name]: null,
                  });
            }
        }
        else{
            setTarifToSave({
                ...tarifToSave,
                [name]: value
            });
        }
    };

    const isValidate = (): boolean => {
        // Reinitialise les variables des validations
        setErrorInput(resetInpuValidation);

        if (!CheckAttr(tarifToSave?.date_debut) ||
            !CheckAttr(tarifToSave?.date_debut) ||
            (!CheckAttr(tarifToSave?.tarif_heure) && !CheckAttr(tarifToSave?.tarif_acte))) {
            if (!CheckAttr(tarifToSave?.date_debut)) {
                setErrorInput((prev: InputValidation) => ({
                    ...prev,
                    dateDebut: true,
                }));
            }

            if (!CheckAttr(tarifToSave?.tarif_heure) && !CheckAttr(tarifToSave?.tarif_acte)) {
                setErrorInput((prev: InputValidation) => ({
                    ...prev,
                    tarif: true
                }));
            }

            setAlerteMessage("Merci de remplir les champs en rouge SVP!");
            setAlertType("warning");
            setOpenSnack(true);

            return false;
        }

        return true;
    };

    const handleSave = () => {
        if (isValidate()) {
            setIsClickSave(true);
            // Control chevauchement
            http.post(`tarification/check/over-lap`, tarifToSave)
                .then(res => {
                    const { isExist } = res.data;

                    if (isExist) {
                        setAlerteMessage("Il y avait déjà un tarif paramétrer entre l’intervalle de date saisis !");
                        setAlertType("warning");
                        setOpenSnack(true);
                        setIsClickSave(false);
                    } else {
                        http.post('tarification/duplicate', tarifToSave)
                            .then(() => {
                                setAlerteMessage("Duplication effectuée !");
                                setAlertType("success");
                                setOpenSnack(true);
                                onClose();
                                reloadList();
                            }).catch(error => {
                                console.log(error);
                                setAlertType("error");
                                setOpenSnack(true);
                            }).finally(() => {
                                setIsClickSave(false);
                                // setDialogLoading(false);
                            });
                    }
                }).catch(error => {
                    console.log(error);
                    setAlertType("error");
                    setOpenSnack(true);
                    setIsClickSave(false);
                });
        }
    };

    const handleCloseAlert = () => {
        setOpenSnack(false);
    };

    const stackAlert: JSX.Element = SnackBarAlert(
        openSnack,
        handleCloseAlert,
        alertType,
        alertMessage
    );

    const codeArticle = rowtarifToUpdate?.article?.code_article?.libelle;
    const disableHeureInput = (): boolean => {
        if (CheckAttr(tarifToSave?.tarif_acte) ||
            checkViaCodeArticle(codeArticleNotToDisable, ['A', 'a'], codeArticle)
        ) {
            return true;
        }

        return false;
    }

    const disableActeInput = (): boolean => {
        if (CheckAttr(tarifToSave?.tarif_heure) ||
            checkViaCodeArticle(codeArticleNotToDisable, ['H', 'h'], codeArticle)
        ) {
            return true;
        }

        return false;
    }

    return (
        <Fragment>
            {stackAlert}
            <Box
                sx={{
                    // Width: '100%',
                }}
            >
                <Grid container spacing={2} columns={{ xs: 6, sm: 12, md: 4 }}>
                    <Grid item xs={6} sm={6} md={2}>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            sx={{ marginLeft: 1, marginTop: 1 }}
                        >
                            <InputLabel
                                htmlFor="pays"
                                color="warning"
                                shrink={CheckAttr(tarifToSave?.pays)}
                            >
                                Pays
                            </InputLabel>
                            <Select
                                id="pays"
                                native
                                color="warning"
                                disabled
                                value={tarifToSave?.pays}
                                label="Pays"
                            >
                                <option value=""></option>
                                {dataPays.map((pays) => (
                                    <option key={pays?.id} value={pays?.id}>
                                        {pays?.libelle}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={6} md={2}>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            sx={{ marginLeft: 1, marginTop: 1 }}
                        >
                            <InputLabel
                                htmlFor="bu"
                                color="warning"
                                shrink={CheckAttr(tarifToSave?.bu)}
                            >
                                Business Unit
                            </InputLabel>
                            <Select
                                id="bu"
                                native
                                color="warning"
                                disabled
                                value={tarifToSave?.bu}
                                label="Business Unit"
                                inputProps={{
                                    name: "bu",
                                }}
                            >
                                <option value=""></option>
                                {dataBus?.map((bu) => (
                                    <option key={bu?.id} value={bu?.id}>
                                        {bu?.libelle}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={6} sm={6} md={2}>
                        <FormControl
                            variant="outlined"
                            className={classes.formControl}
                            sx={{ marginLeft: 1, marginTop: 1 }}
                        >
                            <InputLabel
                                htmlFor="client"
                                color="warning"
                                shrink={CheckAttr(tarifToSave?.client)}
                            >
                                Client
                            </InputLabel>
                            <Select
                                id="client"
                                native
                                color="warning"
                                disabled
                                value={tarifToSave?.client}
                                label="Client"
                                inputProps={{
                                    name: "client",
                                }}
                            >
                                <option value=""></option>
                                {dataClients.map((client) => (
                                    <option key={client?.id} value={client?.id}>
                                        {client?.libelle}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    <Grid item xs={6} sm={6} md={2}>
                        <TextField
                            label="Operation"
                            color="warning"
                            fullWidth
                            autoComplete="off"
                            disabled
                            sx={{ mt: 1, ml: 1 }}
                            value={tarifToSave?.operation_libelle}
                            InputLabelProps={{
                                shrink: CheckAttr(tarifToSave?.operation_libelle),
                            }}
                        />
                    </Grid>

                    <Grid item xs={6} sm={6} md={2}>
                        <TextField
                            label="Article"
                            color="warning"
                            fullWidth
                            autoComplete="off"
                            sx={{ ml: 1 }}
                            disabled
                            value={tarifToSave?.article_libelle}
                            InputLabelProps={{
                                shrink: CheckAttr(tarifToSave?.article_libelle),
                            }}
                        />
                    </Grid>

                    <Grid item xs={6} sm={6} md={2}>
                        <TextField
                            name="date_debut"
                            label="Date debut"
                            type="date"
                            color="warning"
                            fullWidth
                            sx={{ ml: 1 }}
                            error={!CheckAttr(tarifToSave?.date_debut)}
                            value={tarifToSave?.date_debut}
                            inputProps={{
                                min: rowtarifToUpdate?.date_debut
                            }}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: CheckAttr(tarifToSave?.date_debut),
                            }}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6} md={2}>
                        <TextField
                            name="tarif_heure"
                            label="Tarif Heure"
                            type="number"
                            color="warning"
                            fullWidth
                            sx={{ ml: 1 }}
                            autoComplete="off"
                            value={tarifToSave?.tarif_heure}
                            error={errorInput.tarif}
                            disabled={disableHeureInput()}
                            onChange={handleChange}
                            InputLabelProps={{
                                shrink: CheckAttr(tarifToSave?.tarif_heure),
                            }}
                        />
                    </Grid>
                    <Grid item xs={6} sm={6} md={2}>
                        <TextField
                            name="tarif_acte"
                            label="Tarif Acte"
                            type="number"
                            color="warning"
                            fullWidth
                            sx={{ ml: 1 }}
                            autoComplete="off"
                            value={tarifToSave?.tarif_acte}
                            error={errorInput.tarif}
                            onChange={handleChange}
                            disabled={disableActeInput()}
                            InputLabelProps={{
                                shrink: CheckAttr(tarifToSave?.tarif_acte),
                            }}
                        />
                    </Grid>
                </Grid>
                <Box display="flex" justifyContent="center" mt={5}>
                    <LoadingButton
                        onClick={() => handleSave()}
                        endIcon={<BorderColorIcon />}
                        loading={isClickSave}
                        loadingPosition="end"
                        sx={{ textTransform: "none" }}
                        variant="contained"
                        color="warning"
                    >
                        Dupliquer
                    </LoadingButton>
                </Box>
            </Box>
            <Dialog
                open={openModalConfirmation}
                TransitionComponent={Transition}
                keepMounted
                onClose={(e) => setOpenModalConfirmation(false)}
                aria-describedby="alert-dialog-slide-description"
                maxWidth="xs"
            >
                <DialogTitle>{"Confirmation"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {alertMessage}
                        <br /><br />
                        Voulez-vous continuer ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <LoadingButton
                        // onClick={() => saveTarificationSansCondition()}
                        endIcon={<CheckIcon />}
                        loadingPosition="end"
                        sx={{ textTransform: "none" }}
                        variant="contained"
                        color="warning"
                        loading={isClickSave}
                        size="small"
                    >
                        Oui
                    </LoadingButton>
                    <Button
                        onClick={(e) => setOpenModalConfirmation(false)}
                        variant="contained"
                        color="inherit"
                        sx={{ textTransform: "none" }}
                        startIcon={<ExitToAppIcon />}
                        size="small"
                    >
                        Non
                    </Button>
                </DialogActions>
            </Dialog>
        </Fragment>
    );
};

export default DuplicateTarifForm;